import { all, call, put, takeLatest } from "redux-saga/effects";
import { IResponse, Team } from "../../types/global/types";
import { GetTeam } from "../../types/sagas";
import { updateToken } from "../../utils/updateToken";
import { teamAPI } from "../api/api";
import { actionTypes } from "../store/reducers/teamReducer";
import { generalActions } from "../store/reducers/generalReducer";
import { SagaWrapper } from "./index";

function* getTeam(payload: GetTeam) {
  try {
    const response: IResponse<Team> = yield teamAPI.getTeam({
      ...payload,
    });

    if (response.status === 200) {
      yield put({
        type: actionTypes.GET_TEAM_SUCCESS,
        payload: response.data,
      });
    }
  } catch (error) {
    console.log(error);
  }
}

function* deleteTeam({ type, id }: any) {
  try {
    const response: { status: number } = yield teamAPI.deleteTeam(id);
    if (response.status === 200) {
      yield updateToken();
      yield call(getTeam, {});
    }
  } catch (error: any) {
    yield put(
      generalActions.errorAC({
        message: error.response?.data?.message || "An error occurred",
        type: "error",
      })
    );
  }
}

function* updateVisitor ({ request, action, dispatchResponse }: any) {
  const { data, error } = yield request({
    method: 'put',
    endpoint: '/api/auth/invitations/' + action.payload.id,
    body: action.payload.data,
  });

  yield dispatchResponse(
      { data, error },
      actionTypes.UPDATE_VISITOR_SUCCESS,
      actionTypes.UPDATE_VISITOR_ERROR,
  );
}

function* resendLoginLink({ type, id }: any) {
  try {
    const response: { status: number } = yield teamAPI.resendLoginLink(id);
    if (response.status === 200 || response.status === 201) {
      yield put({
        type: actionTypes.RESEND_LOGIN_LINK_SUCCESS,
      });
      yield put(
        generalActions.successAC({
          message: "Login link has been resent successfully.",
          type: "success",
        })
      );
    }
  } catch (error: any) {
    yield put(
      generalActions.errorAC({
        message: error.response?.data?.message || "Failed to resend login link.",
        type: "error",
      })
    );
  }
}

export function* teamWatcher() {
  yield all([
    takeLatest(actionTypes.GET_TEAM, getTeam),
    takeLatest(actionTypes.DELETE_TEAM_TRIGGER, deleteTeam),
    takeLatest(actionTypes.UPDATE_VISITOR_TRIGER, SagaWrapper.withRequest(updateVisitor)),
    takeLatest(actionTypes.RESEND_LOGIN_LINK_TRIGGER, resendLoginLink),
  ]);

}
